import Axios from "@/plugins/Axios";

export class AppConfigurationService {
  async getNotifiqLancamentoStatus() {
    const response = await Axios().get(`app-configurations/notifiq-lancamento-status`);
    return response.data;
  }

  /** Módulos do sistema: catálogo, perfis liberados na franquia e o que o usuário acessa. */
  async getModulos(configuracaoId = null) {
    const params = configuracaoId ? { configuracao_id: configuracaoId } : {};
    const response = await Axios().get("app-configurations/modulos", { params });
    return response.data;
  }

  /** payload: { configuracao_id?, modulos: { chave: ["colaborador", "lider", "admin"] } } */
  async salvarModulos(payload) {
    const response = await Axios().put("app-configurations/modulos", payload);
    return response.data;
  }
}

export default new AppConfigurationService();
